<template>
  <div class="h-full max-h-full overflow-auto rounded-2xl bg-white py-5">
    <template v-if="supplierOrders?.length < 1">
      <div class="mx-auto mt-48 text-center text-slate-300">
        {{ $t('global.there_is_no_yet', { settings: $t(`global.order`) }) }}
      </div>
    </template>
    <template v-else>
      <div class="grid auto-rows-fr grid-cols-1 gap-4 lg:grid-cols-2">
        <div v-for="supplier_order in supplierOrders" :key="supplier_order.id">
          <SupplierOrderSummary
            :supplier-order="supplier_order"
            @refresh="refreshSupplierOrders"
          />
        </div>
      </div>
      <PaginationComponent
        v-if="pagination.total > pagination.per_page"
        class="mt-4"
        :entries-length="pagination.total"
        :page-length="pagination.per_page"
        :current-page="pagination.current_page"
        @update:current-page="$emit('page-change', $event)"
      />
    </template>
  </div>
  <SupplierOrderModal
    :supplier-order="supplierOrder"
    :open="isSupplierOrderModalOpen"
    :dossier="null"
    :force-form="true"
    :metadata="metadata"
    :supplier-orders="supplierOrders"
    :supplier-order-id="selectedSupplierOrderId"
    @fetch-supplier-orders="refreshSupplierOrders"
    @close="handleCloseSupplierOrderModal"
  />
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import SupplierOrderModal from '@ui/modal/supplierOrder/SupplierOrderModal.vue'
import { DocTypes, InvoiceableType } from '@/assets/enums'
import SupplierOrderCardComponent from '@/views/supplierOrder/components/SupplierOrderCardComponent.vue'
import SupplierOrderSummary from '@/views/supplierOrder/components/SupplierOrderSummary.vue'
import PaginationComponent from '@c/PaginationComponent.vue'

export default {
  name: 'SupplierOrdersContainer',
  components: {
    SupplierOrderSummary,
    SupplierOrderCardComponent,
    SupplierOrderModal,
    PaginationComponent
  },
  props: {
    supplierOrders: {
      type: [Object, Array],
      required: true
    },
    metadata: {
      type: [Object, Array],
      required: true
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  emits: ['fetch-supplier-orders', 'page-change'],
  data() {
    return {
      search: '',
      isSupplierOrderModalOpen: false,
      isItemModalOpen: false,
      selectedSupplierOrderIndex: null,
      selectedSupplierOrderId: null,
      selectedSupplierOrderDossier: null,
      selectedItem: null,
      forceForm: false,
      InvoiceableType: InvoiceableType
    }
  },
  computed: {
    ...mapGetters({
      supplierOrder: 'supplierOrder/getSupplierOrder'
    })
  },
  methods: {
    ...mapMutations({
      processSetSupplierOrderMutation: 'supplierOrder/setSupplierOrder'
    }),
    refreshSupplierOrders() {
      this.$emit('fetch-supplier-orders')
    },
    handleCloseSupplierOrderModal() {
      this.isSupplierOrderModalOpen = false
    },
    handleEditSupplierOrder(supplier_order) {
      this.processSetSupplierOrderMutation(supplier_order)
      this.selectedSupplierOrderDossier = this.supplierOrder?.dossier
      this.selectedSupplierOrderId = supplier_order.id
      this.forceForm = true
      this.isSupplierOrderModalOpen = true
    },
    handelSearchInput(newValue) {
      this.searchTerms = newValue
    },
    filtrableColumns() {
      return this.invoicingColumns
        .filter(function (column) {
          return 'searchable' in column && column.searchable
        })
        .map((obj) => {
          return {
            field: obj.field,
            type: obj.type
          }
        })
    },
    handleAddOrder() {
      this.forceForm = false
      this.isSupplierOrderModalOpen = true
    },
    deleteSupplierOrder(supplier_order_id) {
      this.deleteInvoiceById({
        supplier_order_id: supplier_order_id,
        doc_type: DocTypes.SUPPLIER_ORDER,
        recipient_type: InvoiceableType.SUPPLIER,
        supplier_order_index: null,
        successCallback: () => {
          const toast = cash('#notification-with-actions-content').clone()
          toast.find('#undo_btn').on('click', () => {
            this.processUndoDeleteInvoiceAction({
              supplier_order_id: supplier_order_id,
              doc_type: DocTypes.SUPPLIER_ORDER,
              recipient_type: InvoiceableType.SUPPLIER,
              supplier_order_index: null
            })
          })
          this.$h.toastifyHtml({
            close: true,
            duration: 5000,
            node: toast.removeClass('hidden')[0],
            onClick: () => {
              toast.remove()
            }
          })
        }
      })
    }
  }
}
</script>
